import { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { formatEUR } from "@/lib/api";

export const DeleteCustomerDialog = ({ api, customer, name, onOpenChange, onConfirm, deleting }) => {
  const [sel, setSel] = useState([]);
  useEffect(() => { setSel([]); }, [customer]);
  const { data: comms = [], isLoading } = useQuery({
    queryKey: ["customer-commissions", customer?.id],
    queryFn: async () => (await api.get(`/admin/customers/${customer.id}/commissions`)).data,
    enabled: !!customer,
  });
  if (!customer) return null;
  const toggle = (id, v) => setSel(v ? [...sel, id] : sel.filter((x) => x !== id));
  return (
    <Dialog open={!!customer} onOpenChange={onOpenChange}>
      <DialogContent data-testid="delete-customer-dialog">
        <DialogHeader><DialogTitle>Cancellare {name}?</DialogTitle></DialogHeader>
        <div className="space-y-3 text-sm">
          <p className="text-slate-600">Vengono rimossi la scheda cliente e i suoi documenti. L'operazione non si può annullare.</p>
          {isLoading && <p className="text-slate-500">Caricamento provvigioni…</p>}
          {!isLoading && comms.length === 0 && <p className="text-slate-500">Il cliente non ha provvigioni.</p>}
          {comms.length > 0 && (
            <div>
              <p className="text-xs text-slate-600 mb-2">Selezioni le provvigioni da cancellare. Quelle non selezionate restano nello storico; quelle pagate non si possono cancellare.</p>
              <div className="border border-[#E2DDD5] rounded-lg divide-y divide-[#E2DDD5]">
                {comms.map((c) => (
                  <label key={c.id} className="flex items-center gap-3 px-3 py-2" data-testid={`delcust-comm-${c.id}`}>
                    <Checkbox disabled={c.status === "paid"} checked={sel.includes(c.id)} onCheckedChange={(v) => toggle(c.id, v)} data-testid={`delcust-check-${c.id}`} />
                    <span className="font-mono text-xs">{c.period}</span>
                    <span className="font-semibold">{formatEUR(c.amount)}</span>
                    <span className="ml-auto text-xs text-slate-500">{c.status === "paid" ? "Pagata" : "Da pagare"}</span>
                  </label>
                ))}
              </div>
            </div>
          )}
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
          <Button disabled={deleting || isLoading} onClick={() => onConfirm(sel)} className="bg-rose-700 hover:bg-rose-800 text-white" data-testid="delete-customer-confirm">Cancella cliente</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
